import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useRouter } from 'next/navigation'

import ModalContactForm from "components/Forms/Contact/PropertyContactModal";

import { modalSet } from "_slices/view";
import { getUserDetails } from "context/context";

type Props = {
  id: string,
  address: object,
  docType: string,
  name: string,
  agents: [],
  hasBid: boolean | undefined,
  premium: boolean | undefined,
  agentsContactable: boolean
}

type State = {
  view: {
    modal: any
  },
  auth: {
    loggedIn: boolean
  }
}

const ContactForm = (props) => {
  const reduxDispatch = useDispatch();
  const modal = useSelector((state: State) => state.view.modal);
  const loggedIn = useSelector((state: State) => state.auth.loggedIn);
  const userDetails = getUserDetails();
  const { id, address, docType, name, agents = [], hasBid, premium, agentsContactable }: Props = props;
  const router = useRouter();

  let agentList = agents;
  if(!agentsContactable) {
    agentList = agents.filter(agent => agent.paying_client)
  }


  let property = {
    type: docType,
    id: id,
    name: name,
    address: address,
    hasBid: hasBid,
    premium: premium,
  };

  const closeModal = () => {
    reduxDispatch(
      modalSet({
        visible: false,
        router
      })
    );
    reduxDispatch({ type: "contactFormReset" });
    const myBody = document.body;
    if(myBody && myBody.classList.contains('ContactForm__Body--open')) {
      myBody.classList.remove('ContactForm__Body--open')
    }
  };

  useEffect(() => {
  }, [loggedIn, userDetails]);


  return (
    <ModalContactForm
      user={userDetails}
      property={property}
      agents={agentList}
      id="contactUs"
      resultId={id}
      form={[]}
      onSubmit={(e) => {
        e.preventDefault();
      }}
      modal={{
        id: "contactUsModal",
        isOpen: modal.type === "contactProperty" && modal.visible,
        label: `Send a message`,
        closeModal: closeModal,
        onClick: (e) => {
          e.stopPropagation();
        },
      }} />
  );
};

export default ContactForm;
